import { get, getRawValue } from '../../../utils/get';
export var EVENT_CLOSED_STATUS = ['CLOSED', 'CLOSED_MANUALLY'];
export var STOCK_STATUS = {
  SOLD_OUT: 'SoldOut',
  IN_STOCK: 'InStock'
};
export var getStockStatus = function getStockStatus(ticket) {
  if (ticket === void 0) {
    ticket = {};
  }

  var limitPerCheckout = parseInt(getRawValue(ticket, 'limitPerCheckout') || 0);
  return limitPerCheckout ? STOCK_STATUS.IN_STOCK : STOCK_STATUS.SOLD_OUT;
};